import { BsCheck } from 'react-icons/bs';
import { useEffect, useState } from 'react';
interface Iprops {
    label?: string;
    value: string | number;
    uncheckvalue?:string | number;
    checked?: boolean;
    onChange?: (value: string | number) => void
}
const CheckBox = ({ label, value,uncheckvalue='', checked = false, onChange }: Iprops) => {
    const [selected, setSelected] = useState(checked);
    const onChecked = () => {
        setSelected(!selected)
        onChange && onChange(selected === false ? value : uncheckvalue);
    }
    useEffect(() => {
        setSelected(checked)
    }, [checked])
    return (
        <span className='flex gap-3 cursor-pointer' onClick={onChecked}>
            <span className={selected === true ? 'checkbox checked' : 'checkbox'}>
                <span>
                    <BsCheck />
                </span>
            </span>
            {label &&
                <span className='text color-text-deep'>
                    {label}
                </span>}
        </span>
    )
}
export default CheckBox;